// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

function Information({ information }) {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              {information.listInformation.map((item) => (
                <Grid key={item.title} item xs={12} md={6}>
                  <MKBox mb={5}>
                    <DefaultInfoCard
                      icon={item.icon}
                      title={item.title}
                      description={item.description}
                    />
                  </MKBox>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={information.cardInformation.image}
              title={information.cardInformation.title}
              description={information.cardInformation.description}
              action={{
                type: "internal",
                route: information.cardInformation.actionRoute,
                color: "info",
                label: information.cardInformation.actionLabel,
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

Information.propTypes = {
  information: PropTypes.object,
};

export default Information;
